// Erzähl-Flow: fortlaufende Aufnahme in Segmenten (Entscheidung 2B). Alle
// `seconds` Sekunden wird der laufende MediaRecorder gestoppt und sofort ein
// neuer gestartet, damit jedes Segment eigenständig dekodierbar ist; das
// Segment geht an UNSEREN Server (serverseitige Transkription, Mistral), der
// mit dem gesamten Transkript antwortet. Der Server hält den Text: während
// der Aufnahme ist das Textfeld gesperrt und zeigt den Serverstand, nach dem
// Stoppen ist es editierbar. Die Web Speech API ist verboten.

let session = null

function setStatus(wrapper, text) {
  wrapper.querySelector('.audio-status').textContent = text
}

function setButton(button, recording) {
  button.classList.toggle('-recording', recording)
  button.querySelector('.audio-label').textContent = recording ? 'Aufnahme läuft, zum Stoppen klicken' : 'Aufnahme starten'
}

function transcriptField() {
  return document.getElementById('narration_transcript')
}

function lockTranscript(locked) {
  const field = transcriptField()
  if (!field) return
  field.readOnly = locked
  field.classList.toggle('-locked', locked)
}

// Uploads laufen nacheinander, damit Segmente in Reihenfolge ankommen, auch
// wenn eine Umwandlung länger dauert als ein Segment.
let uploadChain = Promise.resolve()

function enqueueUpload(wrapper, blob) {
  uploadChain = uploadChain.then(() => uploadSegment(wrapper, blob))
  return uploadChain
}

function reloadPanel() {
  const panel = document.getElementById('erkannt')
  if (panel && window.up) window.up.reload(panel).catch(() => {})
}

async function uploadSegment(wrapper, blob) {
  const formData = new FormData()
  formData.append('audio', blob, 'segment.webm')
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

  try {
    const response = await fetch(wrapper.dataset.segmentsUrl, {
      method: 'POST',
      headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {},
      body: formData,
    })
    const data = await response.json()
    if (response.ok && data.transcript !== undefined) {
      const field = transcriptField()
      if (field) field.value = data.transcript
      setStatus(wrapper, `${data.segments} Stück umgewandelt.`)
      reloadPanel()
    } else {
      setStatus(wrapper, data.error || 'Ein Stück konnte gerade nicht umgewandelt werden, die Aufnahme läuft weiter.')
    }
  } catch {
    setStatus(wrapper, 'Ein Stück konnte gerade nicht umgewandelt werden, die Aufnahme läuft weiter.')
  }
}

function startSegment(state) {
  let recorder
  try {
    recorder = new MediaRecorder(state.stream)
  } catch {
    state.running = false
    setStatus(state.wrapper, 'Aufnahme wird von diesem Browser nicht unterstützt, Sie können den Text auch tippen.')
    finishSession(state)
    return
  }
  const chunks = []
  recorder.addEventListener('dataavailable', (event) => chunks.push(event.data))
  recorder.addEventListener('stop', () => {
    const blob = new Blob(chunks, { type: recorder.mimeType || 'audio/webm' })
    state.pending += 1
    enqueueUpload(state.wrapper, blob).finally(() => {
      state.pending -= 1
      if (!state.running && state.pending === 0) finishSession(state)
    })
  })
  recorder.start()
  state.recorder = recorder
  state.timer = setTimeout(() => {
    if (!state.running) return
    recorder.stop()
    startSegment(state)
  }, state.seconds * 1000)
}

function finishSession(state) {
  state.stream.getTracks().forEach((track) => track.stop())
  lockTranscript(false)
  setStatus(state.wrapper, 'Aufnahme beendet. Lesen Sie den Text nach, ändern Sie ihn bei Bedarf und gehen Sie dann zur Prüfung.')
  session = null
}

async function startSession(wrapper, button) {
  let stream
  try {
    stream = await navigator.mediaDevices.getUserMedia({ audio: true })
  } catch {
    setStatus(wrapper, 'Das Mikrofon ist nicht freigegeben, Sie können den Text auch tippen.')
    return
  }

  session = { wrapper, stream, running: true, pending: 0, seconds: Number(wrapper.dataset.seconds) || 60, recorder: null, timer: null }
  lockTranscript(true)
  setButton(button, true)
  setStatus(wrapper, 'Aufnahme läuft …')
  startSegment(session)
}

function stopSession(button) {
  if (!session) return
  const state = session
  state.running = false
  clearTimeout(state.timer)
  setButton(button, false)
  setStatus(state.wrapper, 'Letztes Stück wird umgewandelt …')
  if (state.recorder && state.recorder.state === 'recording') {
    state.recorder.stop()
  } else if (state.pending === 0) {
    finishSession(state)
  }
}

// Event-Delegation statt up.compiler (siehe CLAUDE.md).
document.addEventListener('click', (event) => {
  const button = event.target.closest('.narration-record-btn')
  if (!button) return
  event.preventDefault()
  const wrapper = button.closest('.narration-recorder')
  if (session) {
    stopSession(button)
  } else {
    startSession(wrapper, button)
  }
})

// Solange die Aufnahme läuft, warnt der Browser vor dem Verlassen der Seite.
window.addEventListener('beforeunload', (event) => {
  if (!session) return
  event.preventDefault()
  event.returnValue = ''
})

// Unpoly tauscht Fragmente ohne beforeunload: verschwindet die Aufnahme-
// Fläche aus der Seite, wird die Sitzung beendet und das Mikrofon freigegeben.
if (window.up) {
  window.up.on('up:fragment:destroyed', () => {
    if (session && !document.body.contains(session.wrapper)) {
      const button = session.wrapper.querySelector('.narration-record-btn')
      stopSession(button)
    }
  })
}
